module.exports = __webpack_public_path__ + "static/media/proj20_img6.8dad43ba.jpg";